module.exports = __webpack_public_path__ + "images/08-01@2x_da32b356.png";